import React from 'react';
import { TemplateBuilderContainer } from './Components/TemplateBuilderContainer';
import {
  TemplateBuilder,
  TemplateBuilderFactory,
} from './Components/TemplateBuilderFactory';
import { TemplateBuilderInputTriggerSection } from './Components/TemplateBuilderInputTriggerSection';
import { TemplateBuilderReengagementSection } from './Components/TemplateBuilderReengagementSection';
import { TemplateSubsectionLink } from './Components/TemplateSubsectionLink';

export const CallbackKingBuilder: TemplateBuilder = ({ maxFollowUpCounts }) => (
  <TemplateBuilderFactory template="callback_king" {...maxFollowUpCounts}>
    {props => {
      return (
        <TemplateBuilderContainer
          enabled={!props.busy && props.isValid}
          confirm={props.confirm}
        >
          <TemplateBuilderInputTriggerSection>
            <div>
              On {props.channelName}, when someone {props.triggersSelect}, send{' '}
              {props.channelMessageName} to attempt to collect their{' '}
              {props.collectionSelect}, then ask them{' '}
              {props.qualifyingQuestionSelect}, and send them an irresistible
              offer to call you now.
            </div>
          </TemplateBuilderInputTriggerSection>
          <TemplateSubsectionLink />
          <TemplateBuilderReengagementSection>
            <div>
              Using the data collected from {props.channelName}, if the lead has
              a phone number but has not called, send them a{' '}
              {props.unicornEmailSelect} Email and {props.unicornSMSSelect} SMS
              text message sequence with a super enticing offer with a call to
              action of calling you back.
            </div>
          </TemplateBuilderReengagementSection>
        </TemplateBuilderContainer>
      );
    }}
  </TemplateBuilderFactory>
);
